'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = require('clappr/src/base/events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fired when playback changes rate
 *
 * @event CONTAINER_RATEUPDATE
 * @param {Float} playback rate
 */
_events2.default.CONTAINER_RATEUPDATE = 'container:rateupdate';

/**
 * Fired when playback changes rate
 *
 * @event PLAYBACK_RATEUPDATE
 * @param {Float} playback rate
 */
_events2.default.PLAYBACK_RATEUPDATE = 'playback:rateupdate';
/**
 * Fired when playback rate is changed
 *
 * @event PLAYER_PLAYBACK_RATE
 * @param {Float} playback rate
 */
_events2.default.PLAYER_PLAYBACK_RATE = 'playbackrate';

exports.default = _events2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/overrides/clappr/base/events.js
// module id = 23
// module chunks = 2